import { render, staticRenderFns } from "./EvaluateSampleConfig.vue?vue&type=template&id=56b2fbf4&scoped=true"
import script from "./EvaluateSampleConfig.vue?vue&type=script&lang=js"
export * from "./EvaluateSampleConfig.vue?vue&type=script&lang=js"
import style0 from "./EvaluateSampleConfig.vue?vue&type=style&index=0&id=56b2fbf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b2fbf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b2fbf4')) {
      api.createRecord('56b2fbf4', component.options)
    } else {
      api.reload('56b2fbf4', component.options)
    }
    module.hot.accept("./EvaluateSampleConfig.vue?vue&type=template&id=56b2fbf4&scoped=true", function () {
      api.rerender('56b2fbf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/EvaluateSampleConfig.vue"
export default component.exports